module.exports = __webpack_public_path__ + "img/dd-logo-hyundai.1602e046.png";